module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAXElEQVQ4T2NkIBMwgvT9////P4juPMjAcPsNpkmqIgwM5fYIcUYQQNaYspaBYU4wpkZ08VGNSGFEVODgilbk0KZNqIISAyzSiXIqWQkAV5JTEWZgqHDAkuTISecAXYJgD+jVgzMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/header/images/headerMobile@2x.png
// module id = tcxd
// module chunks = 27